import NextStepImpact from "features/Cpat/NextStepImpact"
import ExploreResources from "features/Home/ExploreResources"
import GetStartedWithProgramsBanner from "features/Home/GetStartedWithProgramsBanner"
import { context } from "global/Context/context"
import { useContext } from "react"
import { useEnrollments } from "utils/hooks/useEnrollments"

import { CpatFaqs } from "../../Faqs"
import CpatResultBanner from "./CpatResultBanner"

const CpatCompletedDashboard = () => {
  const { currentGrowthspace } = useContext(context)
  const {
    cpat: { throughGSG },
  } = useEnrollments()

  return (
    <div>
      <CpatResultBanner />
      <NextStepImpact />
      {!currentGrowthspace?.organization && (
        <div>
          {!throughGSG && <GetStartedWithProgramsBanner className="mb-8" />}
          <ExploreResources />
        </div>
      )}
      {!throughGSG && <CpatFaqs assessmentCompleted={true} />}
    </div>
  )
}

export default CpatCompletedDashboard
